import { useMemo } from 'react'

import { Grid } from '@mui/material'

import { TextInput } from 'components/common'
import { Booking, BookingStatus } from 'generated/graphql'
import { useIsBookingDisabled } from 'hooks'

import ContainerStatus from './ContainerStatus'
import ContainerTitle from './ContainerTitle'
import PobPodButtons from './PobPodButtons'

interface ISupplierMainBookingDetailsProps {
  bookingDetails: Booking
  loading?: boolean
}

const SupplierMainBookingDetails = (props: ISupplierMainBookingDetailsProps) => {
  const { bookingDetails } = props
  const isPobPodButtonsDisabled = useMemo(
    () => !bookingDetails.status || bookingDetails.status === BookingStatus.Waiting,
    [bookingDetails.status],
  )

  const isBasicDisabled = useIsBookingDisabled(bookingDetails)

  return (
    <div>
      <Grid container justifyContent='space-between'>
        <ContainerTitle isQuote={false} disabled={isBasicDisabled} />

        <ContainerStatus bookingDetails={bookingDetails} />
      </Grid>

      <Grid container spacing={1.5}>
        <Grid
          item
          xs={12}
          md='auto'
          alignSelf='center'
          ml={{ lg: 'auto' }}
          sx={{ order: { xs: 3, md: 1, lg: 6 } }}>
          <PobPodButtons
            hoverText=''
            disabled={isBasicDisabled}
            isPobPodButtonsDisabled={isPobPodButtonsDisabled}
            bookingId={bookingDetails.id}
          />
        </Grid>

        {/* Customer data */}
        <Grid
          container
          item
          xs={12}
          sm={6}
          md={12}
          lg={6.7}
          xl={7}
          sx={{ order: { xs: 4, lg: 1 } }}>
          <Grid container spacing={0.5}>
            <Grid item xs zeroMinWidth>
              <TextInput label='Customer' readOnly value={bookingDetails.customer.name} />
            </Grid>

            <Grid item xs={12} md>
              <TextInput
                label='Cust. Ref. / PO number'
                readOnly
                value={bookingDetails.customerReference}
              />
            </Grid>

            <Grid item xs={12} md>
              <TextInput label='Booking Ref' readOnly value={bookingDetails.ourReference} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default SupplierMainBookingDetails
